"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ReportAConcernPageContainer = void 0;
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _constants = require("../../constants");
var _constantsGenerated = require("../../constants-generated");
var _concernFormContext = require("../../contexts/concernFormContext");
var _logger2 = require("../../logger");
var _ApiProvider = require("../ApiProvider");
var _ConcernFormContainer = require("../ConcernFormContainer/ConcernFormContainer");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file -- no tests for containers */ const ReportAConcernPageContainer = (param)=>{
    let { formConfig, formData } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
        team: _testidGenerator.Team.Presentation,
        project: _constantsGenerated.APP_NAME,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
            logger: _logger2.mainLogger,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
                areaName: "ReportAConcernPageContainer",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ApiProvider.ApiProvider, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
                        namespace: _constants.translationsNamespace,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_concernFormContext.ConcernFormProvider, {
                            formConfig: formConfig,
                            formData: formData,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ConcernFormContainer.ConcernFormContainer, {})
                        })
                    })
                })
            })
        })
    });
};
exports.ReportAConcernPageContainer = ReportAConcernPageContainer;
